import WebServiceRequest from "../Api/WebServiceRequest";

class VideoSiteMapsCreate extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag("VideoSiteMaps/Create");
    }
    setParams(data) {
        super.setRequestParamDataObj(data);
    }
}

class VideoSiteMapsGetAll extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag("VideoSiteMaps/GetAll");
    }
    setParams(data) {
        super.setRequestParam(data);
    }
}

class VideoSiteMapsGet extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag("VideoSiteMaps/Get");
    }
    setParams(data) {
        super.setRequestParam(data);
    }
}

class VideoSiteMapsUpdate extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag("VideoSiteMaps/Update");
    }
    setParams(data) {
        super.setRequestParamDataObj(data);
    }
}

class VideoSiteMapsDelete extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag("VideoSiteMaps/Delete");
    }
    setParams(data) {
        super.setRequestParam(data);
    }
}

export {
    VideoSiteMapsCreate,
    VideoSiteMapsGetAll,
    VideoSiteMapsGet,
    VideoSiteMapsUpdate,
    VideoSiteMapsDelete
}